<template>
  <div class="relative">
    <div><p class=" font-black pb-5 text-2xl text-white font-roboto md:text-3xl text-center">
      {{ translations[language].moregames }}</p></div>
    <div class="carousel-wrapper">
      <div class="swiper-container" ref="swiperContainer">
        <div class="swiper-wrapper flex justify-center">
          <div v-for="(game, index) in filteredGames" :key="index" class="swiper-slide">
            <article
                class="rounded-xl bg-gray-800 bg-opacity-30 duration-200 hover:-translate-y-4 p-3 shadow-lg hover:shadow-xl">
              <router-link :to="game.route">
                <div class="relative flex items-end overflow-hidden rounded-xl">
                  <img :src="require(`@/assets/${game.image}`)" alt="Game Photo"/>
                </div>
                <div class="mt-1 p-2">
                  <h2 class="text-slate-400 font-bold text-center">{{ game.title }}</h2>
                </div>
              </router-link>
            </article>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="justify-center items-center pt-5 flex">
    <div class="inset-x-0 bottom-4 flex justify-between">
      <button @click="prevSlide" class="left-4 bg-gray-900/70 text-white py-2 px-4 rounded-md" style="z-index: 1;">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
             xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
        </svg>
      </button>

      <button @click="nextSlide" class="right-4 bg-gray-900/70 text-white py-2 px-4 rounded-md" style="z-index: 1;">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
             xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
        </svg>
      </button>
    </div>
  </div>
</template>


<script>
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

export default {
  name: "MoreGames",
  props: {
    excludedGames: {
      type: Array,
      default: () => [],
    },
    language: {
      type: String,
      default: 'pt'
    }
  },
  data() {
    return {
      translations: {
        pt: {
          moregames: 'Conheça outros jogos da Mito Games',
        },
        en: {
          moregames: 'Discover other games from Mito Games',
        }
      },
      games: [
        { route: 'boxdungeons', image: 'BoxDungeons.png' },
        { route: 'coredefenders', image: 'CoreDefenders.png' },
        { route: 'planetsea', image: 'PlanetSea.png' },
        { route: 'popsomeeyes', image: 'SomeEyes.png' },
        { route: 'theelements', image: 'TheElements.png' },
        { route: 'wardogsredsreturn', image: 'WarDogs.png' },
        { route: 'willyswonderland', image: 'WillysWonderland.png'},
        { route: 'arariboiajogo', image: 'ArariboiaJogo.png'},
        { route: 'linkolnrhyme', image: 'linkolnrhyme/CAPA.png'},
      ],
      swiper: null,
    };
  },
  computed: {
    filteredGames() {
      return this.games.filter(game => !this.excludedGames.includes(game.route));
    },
  },
  mounted() {
    this.initializeSwiper();
  },
  methods: {
    initializeSwiper() {
      this.swiper = new Swiper(this.$refs.swiperContainer, {
        spaceBetween: 2,
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          1124: {
            slidesPerView: 4,
          },
          1200: {
            slidesPerView: 5,
          },
        },
      });
    },
    nextSlide() {
      this.swiper.slideNext();
    },
    prevSlide() {
      this.swiper.slidePrev();
    }
  },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  },
};
</script>

<style scoped>
.carousel-wrapper {
  width: 100%;
}

.swiper-slide {
  width: 100% ;
}

.rounded-xl {
  width: 100%;
  max-width: 220px;
  margin: 0 auto;
}

</style>

